import ClearIcon from '@mui/icons-material/Clear';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import MenuButton from '../../components/MenuButton';
import NavbarBreadcrumbs from '../../components/NavbarBreadcrumbs';
import Search from '../../components/Search';
import ColorModeIconDropdown from '../../theme/ColorModeIconDropdown';
import TowerDatePicker from './TowerDatePicker';

export default function TowerHeader({
  searchTerm,
  onSearchChange,
  searchInputRef,
  placeholder,
  totalResults,
  totalTrips,
  hasSearch,
  activeFilter,
  hasFilter,
  onClearAllFilters,
  showCards,
  onToggleCards,
  hasStatusFilters,
  selectedStatuses
}) {
  const hasAnyFilter = hasSearch || hasFilter || hasStatusFilters;

  return (
    <Stack
      direction="row"
      sx={{
        display: { xs: 'none', md: 'flex' },
        width: '100%',
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'space-between',
        maxWidth: { sm: '100%', md: '1700px' },
        pt: 1.5,
      }}
      spacing={2}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <NavbarBreadcrumbs />

        {/* Filtros ativos */}
        {hasFilter && (
          <Chip
            label={`Filtro: ${activeFilter.label}`}
            variant="outlined"
            color="primary"
            size="small"
            onDelete={() => onClearAllFilters()}
            deleteIcon={<ClearIcon />}
            sx={{
              fontSize: '0.75rem',
              height: '24px',
              '& .MuiChip-deleteIcon': {
                fontSize: '14px'
              }
            }}
          />
        )}

        {/* Status filters ativos */}
        {hasStatusFilters && (
          <Chip
            label={`Status: ${selectedStatuses.length} selecionado${selectedStatuses.length > 1 ? 's' : ''}`}
            variant="outlined"
            color="secondary"
            size="small"
            onDelete={() => onClearAllFilters()}
            deleteIcon={<ClearIcon />}
            sx={{
              fontSize: '0.75rem',
              height: '24px',
              '& .MuiChip-deleteIcon': {
                fontSize: '14px'
              }
            }}
          />
        )}

        {/* Contadores de resultados */}
        {hasAnyFilter && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: '0.75rem',
              backgroundColor: 'action.hover',
              px: 1.5,
              py: 0.5,
              borderRadius: 1,
              whiteSpace: 'nowrap'
            }}
          >
            {totalResults} de {totalTrips} viagens
          </Typography>
        )}
      </Stack>

      <Stack direction="row" sx={{ gap: 1, alignItems: 'center' }}>
        <Search
          value={searchTerm}
          onChange={onSearchChange}
          inputRef={searchInputRef}
          placeholder={placeholder}
        />

        {/* Botão para limpar todos os filtros */}
        {hasAnyFilter && (
          <Tooltip title="Limpar todos os filtros">
            <IconButton
              onClick={onClearAllFilters}
              size="small"
              color="primary"
              sx={{
                '&:hover': {
                  backgroundColor: 'action.hover'
                }
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        <Tooltip title={showCards ? 'Ocultar cards' : 'Mostrar cards'}>
          <IconButton
            onClick={onToggleCards}
            size="small"
            sx={{
              color: 'text.primary',
              '&:hover': {
                backgroundColor: 'action.hover'
              }
            }}
          >
            {showCards ? <VisibilityOffIcon /> : <VisibilityIcon />}
          </IconButton>
        </Tooltip>

        <TowerDatePicker />

        <MenuButton showBadge aria-label="Notificações">
          <NotificationsRoundedIcon />
        </MenuButton>

        <ColorModeIconDropdown />
      </Stack>
    </Stack>
  );
}
